import Vue from 'vue';
// import i18n from "../../../i18n";

export default {

  async refreshProjectVessels({ dispatch, getters }, pId) {
    console.log('refresh', pId);
    let selProjectId = getters.getSelProjectId;
    if (pId == selProjectId) {
      dispatch('fetchProjectVesselNames', pId);
    }
  },

  async fetchProjectVesselNames({ commit }, projectId) {
    if (!projectId) {
      return new Promise((resolve) => resolve(commit("SET_PROJECT_VESSELS", [])));
    }

    return Vue.axios.get(Vue.$url("project/" + projectId + "/vessels"))
      .then((rsp) => commit("SET_PROJECT_VESSELS", rsp.data))
      .catch((err) => Vue.$err(err) && commit('mShowErrorMessage', err.data.Message, { root: true }));
  },
}